import { Body1 } from '@sainsburys-tech/luna-typography'
import getRelativeDate from '../../../utils/getRelativeDate'
import { IIncidentDescription } from '../../../types'

const IncidentDescription = ({ dateOfIncident, timeOfIncident, location, store, type, fraudDetails }: IIncidentDescription) => {
  
  const date = getRelativeDate({dateTime:dateOfIncident ?? undefined, type:'date'})
  const time = type == "incident" ? getRelativeDate({dateTime:timeOfIncident ?? undefined, type:'time24'}) : timeOfIncident

  return (
    <>
      {fraudDetails && (
        <div>
          <Body1 className="ln-u-color-dark">
            {[fraudDetails.fraudType, fraudDetails.location].filter(Boolean).join(' ')}
            <br />
            {fraudDetails.suspectedFraudType ?? ''}
          </Body1>
        </div>
      )}
      <div>
        <Body1
          className="ln-u-color-dark"
        >
          { date ? ("on "+ date) : ''} {timeOfIncident ? (" at " + time) : ''}
        </Body1>
      </div>
      <div>
        <Body1
          className="ln-u-color-dark"
        >
          {store ? ("at " + store + ",") : ''} {location ? (" in the " + location + '.') : ''}
        </Body1>
      </div>
    </>
  )
}

export default IncidentDescription